<template>
  <div class="container">
    <!-- 原生 select -->
    <div v-if="isPreviewMode">
      渠道：
      <select v-model="currentChannel" @change="previewItemClick($event)">
        <option v-for="item in previewChannels" :key="item" :value="item">
          {{ item }}
        </option>
      </select>
      <iframe v-if="!isShowHTML" style="width: 100%; height: 100%;" id="iframe"></iframe>
    </div>
    <div v-if="isShowHTML" v-html="content"></div>
  </div>
</template>
<script>
import qs from 'qs'
import { getPrivacyAgreement, preview } from './service'
import { Toast } from 'vant'

export default {
  data() {
    return {
      // html内容
      content: '',
      // content: configValue.content,
      // 当前的点击选中 渠道
      currentChannel: '',
      // 预览数据
      previewData: [],
      // 预览的渠道
      previewChannels: []
    }
  },
  computed: {
    isPreviewMode() {
      return this.isPreview()
    },
    isShowHTML() {
      return !!this.content
    }
  },
  async mounted() {
    const query = this.getQuery()
    if (this.isPreview()) {
      await this.previewRequest(query)
    } else {
      // 必要参数 agreementKey, version, channel, platform
      await this.request(query)
    }
    this.$nextTick(() => {
      this.linkInterceptor()
    })
  },
  methods: {
    // 获取 query 参数
    // isPreview: true agreementId
    // isPreview: false agreementKey, version, channel, platform
    getQuery() {
      const query = qs.parse(location.search, { ignoreQueryPrefix: true })
      return query
    },
    // 根据 isPreview 判断是不是预览模式
    isPreview() {
      const query = qs.parse(location.search, { ignoreQueryPrefix: true })
      return !!query.isPreview
    },
    // 协议请求
    async request(record) {
      const loading = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      const params = record
      const header = {}
      const res = await getPrivacyAgreement(params, header)
      if (res.code !== 'SUCCESS') {
        loading.close()
        Toast(res.message, { duration: 3000, position: 'bottom' })
        return false
      }
      loading.close()
      // 新增逻辑，跳转静态 oss html 地址
      if (res.data && res.data.htmlUrl) {
        if (res.data.htmlUrl.indexOf('?') === -1) {
          res.data.htmlUrl += '?'
        } else {
          res.data.htmlUrl += '&'
        }
        const newURL = res.data.htmlUrl + (location.search.split('?')[1] || '')
        this.aNodeLink(newURL)
        return
      }
      this.initAgreement(res.data)
    },
    // 预览请求
    async previewRequest(params) {
      if (!params.agreementId) {
        Toast('缺少参数 agreementId', { duration: 3000, position: 'bottom' })
        return false
      }
      const loading = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      const res = await preview({
        agreementId: params.agreementId
      })
      if (res.code !== 'SUCCESS') {
        loading.close()
        Toast(res.message, { duration: 3000, position: 'bottom' })
        return false
      }
      loading.close()
      this.previewData = res.data || []
      this.previewChannels = this.previewData.map(item => item.channel)
      const firstItem = this.previewData[0]
      if (Array.isArray(res.data) && res.data.length === 0) {
        Toast('预览数据为空, 预览数据30min有效', { duration: 5000 })
        return
      }
      // 新增逻辑，跳转静态 oss html 地址, 默认第一条
      const htmlUrl = res.data[0].htmlUrl
      console.log(`🚀 ~ previewRequest ~ htmlUrl:`, htmlUrl)
      if (htmlUrl) {
        // 截取 ossUrl 字段
        let url = this.interceptStr(htmlUrl, 'ossUrl')
        let query = qs.parse(location.search, { ignoreQueryPrefix: true })
        query.appChannel = res.data[0].channel
        if (this.isPreviewMode) {
          // 删除预览模式冗余字段
          query = this.deleteRedundantField(query)
        }
        const newSearch = qs.stringify(query)
        const iframe = document.getElementById('iframe')
        if (url.indexOf('?') === -1) {
          url += '?'
        } else {
          url += '&'
        }
        iframe.src = url + newSearch
        // todo
        // iframe.src = 'file:///Users/how/Documents/GitHub/market/src/pages/agreement/ossDEMO.html?' + newSearch
        console.log(iframe.src)
        const selectNode = document.querySelector('select')
        const h = selectNode.offsetHeight
        const bodyH = document.querySelector('body').offsetHeight
        iframe.style.height = bodyH - h - 20 + 'px'
        this.currentChannel = res.data[0].channel
        this.title = res.data[0].title
        this.content = ''
        return
      }
      this.initAgreement(firstItem)
    },
    // 预览点击 channel title content
    previewItemClick(e) {
      const record = this.previewData.find(
        item => item.channel === this.currentChannel
      )
      if (record.htmlUrl) {
        let query = qs.parse(location.search, { ignoreQueryPrefix: true })
        query.appChannel = this.currentChannel
        if (this.isPreviewMode) {
          // 删除预览模式冗余字段
          query = this.deleteRedundantField(query)
        }
        if (record.htmlUrl.indexOf('?') === -1) {
          record.htmlUrl += '?'
        } else {
          record.htmlUrl += '&'
        }
        // 删除冗余 ossUrl 字段
        this.interceptStr(record.htmlUrl, 'ossUrl')
        const newSearch = qs.stringify(query)

        const url = record.htmlUrl + newSearch
        console.log(`🚀 ~ previewItemClick ~ url:`, url)
        const iframe = document.getElementById('iframe')
        iframe.src = url
        const selectNode = document.querySelector('select')
        const h = selectNode.offsetHeight
        const bodyH = document.querySelector('body').offsetHeight
        iframe.style.height = bodyH - h - 20 + 'px'
        return
      }
      this.initAgreement(record)
    },
    // 初始化协议
    initAgreement({ title, content, channel }) {
      this.currentChannel = channel
      this.content = content
      this.title = title
      window.document.title = title
    },
    // 删除冗余字段
    deleteRedundantField(query) {
      if (query.isPreview || this.isPreviewMode) {
        if (query.isPreview) {
          delete query.isPreview
        }
        if (query.agreementId) {
          delete query.agreementId
        }
        if (query.id) {
          delete query.id
        }
      }
      return query
    },
    // 截取指定字符的字符串,并截取字符前的?和& 例如：str = '?name=123&a=1' 截取name后 str = 'a=1'
    interceptStr(str, key) {
      const reg = new RegExp('([?|&])' + key + '=[^&]*')
      return str.replace(reg, '')
    },
    // a 标签拦截
    linkInterceptor() {
      // 全局拦截 a 标签跳转
      // 拦截a标签跳转
      document.querySelectorAll('a').forEach(node => {
        // 不是协议地址（不是/market项目，不是/agreement）,无暇计划：/sherlock/market/agreement
        const href = node.href || ''
        const marketAgreement = '/market/agreement'
        node.addEventListener('click', (e) => {
          e.preventDefault()
          e.stopPropagation()
          const isOtherLink = href.indexOf(marketAgreement) === -1
          let url = href
          if (!isOtherLink) {
            e.preventDefault()
            e.stopPropagation()
            let query = qs.parse(location.search, {
              ignoreQueryPrefix: true
            })
            const targetSearch = href.split('?')[1]
            const targetAgreementKey = qs.parse(targetSearch).agreementKey
            // 协议 key 不存在，直接跳转a标签链接
            if (!targetAgreementKey) {
              // window.location.href = href
              this.aNodeLink(href)
              return
            }
            const origin = location.origin
            const pathname = location.pathname
            // 删除预览模式冗余字段
            if (this.isPreviewMode) {
              // 删除预览模式冗余字段
              query = this.deleteRedundantField(query)
            }

            // 修改跳转协议
            const targetQuery = {
              // 预览模式取下拉框选的渠道，非预览模式取 query 里的 appChannel
              appChannel: this.currentChannel,
              ...query,
              agreementKey: targetAgreementKey
            }
            url = origin + pathname + '?' + qs.stringify(targetQuery)
            console.log(`🚀 ~ url:`, url)
          }
          this.aNodeLink(url)
        })
      })
    },
    // ios 模拟用户点击行为
    // 注意：在严格的安全策略下（例如CSP），直接触发click事件可能导致跳转被阻止
    aNodeLink(url) {
      window.location.replace(url)
      // const aNode = document.createElement('a')
      // aNode.id = 'agreement'
      // aNode.href = url
      // aNode.target = '_self'
      // aNode.innerText = url
      // document.body.appendChild(aNode)
      // aNode.style.display = 'none'
      // window.location.href = url
      // aNode.click()
    }
  }
}
</script>

<style lang="scss">
// @import url("./normalize.css");
.container {
  padding: 10px 20px;
  word-break: break-all;
  ol,
  ul {
    margin: 0;
    padding: 0;
    padding-inline-start: 1em;
    list-style: inherit;
  }
  table {
    width: 100%;
    border-collapse: collapse;
  }

  table caption {
    font-size: 2em;
    font-weight: bold;
    margin: 1em 0;
  }

  th,
  td {
    // fix ios 边框问题
    border: 1PX solid #999;
    text-align: center;
    padding: 40px 0;
  }

  table thead tr {
    background-color: #008c8c;
    color: #fff;
  }

  table tfoot tr td {
    text-align: right;
    padding-right: 20px;
  }
  p,
  li {
    min-height: 1em;
  }
}
.preview {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  // position: fixed;
  top: 0;
  right: 0;
  &-item {
    width: fit-content;
    padding: 10px 50px;
    background: #fff;
    border: 1px solid #d9d9d9;
    margin-bottom: 10px;
    &.active {
      background: #d9d9d9;
    }
  }
  &-item + &-item {
    margin-left: 50px;
  }
}
// select 样式

select {
  width: 50%;
  margin: 20px;
}

iframe {
  border: none;
}
</style>
